import Validator from '../../validator/validator.js';

export default angular.module('BaseClass.validatable.validaters.numericality', [Validator])
    .factory('numericality', function(BCValidator) {
        function numericality(value, instance, field) {
            if (!value) return true;
            value = String(value);
            if (this.ignore) value = value.replace(this.ignore, '');
            return !isNaN(Number(value));
        }

        numericality.message = function() {
            return 'is not a number.';
        };


        return new BCValidator(numericality, 'numericality');
    }).name;
